import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setPaisState } from "../../store/actions/permitFormActions/paisStateActions";

const PaisResultsGrid = ({
  products,
  setSelectedProductRow,
  addDisabled,
  setAddDisabled,
}) => {
  const {
    foundProducts: reduxFoundProducts,
    addDisabled: reduxAddDisabled,
    enlargeGrid,
  } = useSelector((state) => state.paisState);

  // Use props if provided, otherwise fall back to Redux state
  const foundProducts = products || reduxFoundProducts;
  const isAddDisabled =
    addDisabled !== undefined ? addDisabled : reduxAddDisabled;

  const dispatch = useDispatch();

  const handleRowClick = (row) => {
    if (setSelectedProductRow) {
      // Use prop function if provided (for ProductLookup modal)
      if (addDisabled && setAddDisabled) {
        setAddDisabled(false);
      }
      setSelectedProductRow(row);
    } else {
      // Use Redux dispatch (for other components)
      if (isAddDisabled) {
        dispatch(setPaisState({ addDisabled: false }));
      }
      dispatch(setPaisState({ selectedProductRow: row }));
    }
  };

  const columns = [
    {
      field: "sub_fl_number",
      headerName: "FL Number",
      flex: 0.5,
      minWidth: 100,
      renderCell: (params) => `FL${params.value}`,
    },
    {
      field: "product_manufacturer",
      headerName: "Manufacturer",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        // Function to add line breaks after every 10 characters
        const addLineBreaks = (text, interval) => {
          const regex = new RegExp(`.{1,${interval}}`, "g");
          return text.match(regex).join("<br />");
        };

        // Applying the line break function
        const formattedText = addLineBreaks(params.value, 18);

        // Returning the formatted text with line breaks
        return <div dangerouslySetInnerHTML={{ __html: formattedText }} />;
      },
    },
    {
      field: "category",
      headerName: "Category",
      width: 250,
      renderCell: (params) => (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="body2">{params.row.category}</Typography>
          <Typography variant="body2">{params.row.subcategory}</Typography>
        </Box>
      ),
    },

    {
      field: "sub_model_number_or_name",
      headerName: "Model Number/Name",
      width: 200,
    },
    { field: "sub_description", headerName: "Description", width: 250 },
    { field: "sub_expiration_date", headerName: "Expiration Date", width: 150 },
  ];

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        maxHeight: enlargeGrid ? "21rem" : undefined,
      }}
    >
      <DataGrid
        rows={foundProducts || []}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5, 10]}
        getRowHeight={() => "auto"}
        onRowClick={(params) => {
          handleRowClick(params.row);
        }}
        // autoHeight={true}
        slotProps={{
          row: {
            sx: { cursor: "pointer" },
          },
        }}
        sx={{
          ".MuiDataGrid-row:hover": {
            cursor: "pointer",
          },
          "& .MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
            outline: "none !important",
          },
          "& .MuiDataGrid-columnHeader:focus-within": {
            outline: "none !important",
          },
          "& .MuiDataGrid-cell": {
            borderColor: "rgba(0, 0, 0, 0.1)",
            p: 0,
            px: 0.5,
          },
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#333333", // Change column header background color
            color: "white",
            fontSize: "15px",
            paddingLeft: 1,
            paddingRight: 2,
            margin: 0,
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0,
          },

          "& .MuiDataGrid-columnHeaders": {
            padding: 0,
            margin: 0,
          },
          "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
            outline: "none !important",
          },
        }}
      />
    </div>
  );
};

export default React.memo(PaisResultsGrid);
